export enum EnvironmentName {
  PROD = 'prod',
  DEV = 'dev',
  TEST = 'test',
}

export interface EnvironmentConfig {
  name: EnvironmentName;
  projectName: string;
  projectVersion: string;
  projectBuildDate: number | string;
  osInterfaceURL: string;
  apiUrl: string;
  apiCentralURL: string;
  keycloakUrl: string;
  apiCentralSoftwareId: string;
  apiSenhasSoftwareId: string;
}

export class AppEnvironment {
  public ENV_NAME: EnvironmentName;
  public PROJECT_NAME: string;
  public PROJECT_VERSION: string;
  public PROJECT_BUILD_DATE: number;
  public OS_INTERFACE_URL: string;
  public API_URL: string;
  public API_CENTRAL_URL: string;
  public KEYCLOAK_URL: string;
  public API_CENTRAL_SOFTWARE_ID: string;
  public API_SENHAS_SOFTWARE_ID: string;

  get isTest(): boolean {
    return this.ENV_NAME === EnvironmentName.TEST;
  }

  get isDev(): boolean {
    return this.ENV_NAME === EnvironmentName.DEV;
  }

  get isProd(): boolean {
    return this.ENV_NAME === EnvironmentName.PROD;
  }

  get buildDate(): string {
    return this.PROJECT_BUILD_DATE.toString();
  }

  get getProjectVersion(): string {
    return this.PROJECT_VERSION;
  }

  get fullVersion() {
    return `Versão: ${this.PROJECT_VERSION} - Build: ${this.buildDate}`;
  }

  get getDomain(): string {
    const homolog = window.location.host.indexOf('homolog') > -1;
    const dev =
      window.location.host.indexOf('localhost') > -1 ||
      window.location.port === '4204';

    if (homolog) {
      return '.homolog.vsd.app.br';
    } else if (dev) {
      return 'localhost';
    } else {
      return '.vsd.app.br';
    }
  }

  get apiURL(): string {
    return this.API_URL;
  }
}
